import React from "react";
import { Form, Input } from "antd";
import { InfoNotification } from "../Notification/ToastNotification";
import { useTranslation } from "react-i18next";
import { FiLock, FiKey, FiShield, FiCheck } from "react-icons/fi";

const PasswordInfo = () => {
  const { t } = useTranslation();

  const passwordRequirements = [
    { text: "At least 8 characters", met: true },
    { text: "One uppercase letter", met: true },
    { text: "One lowercase letter", met: true },
    { text: "One number", met: false },
    { text: "One special character", met: false },
  ];

  return (
    <div style={{ background: "#f8fafc", minHeight: "100vh", padding: "20px 24px" }}>
      {/* Page Header */}
      <div style={{ marginBottom: "24px" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "4px" }}>
          <div
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "12px",
              background: "linear-gradient(135deg, #7C3AED, #6D28D9)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <FiLock size={20} color="white" />
          </div>
          <div>
            <h1 style={{ margin: 0, fontSize: "20px", fontWeight: 600, color: "#1e293b" }}>
              {t("profile.plans.changePassword")}
            </h1>
            <p style={{ margin: 0, fontSize: "13px", color: "#64748b" }}>
              {t("profile.plans.changePasswordInfo")}
            </p>
          </div>
        </div>
      </div>

      <div style={{ display: "flex", gap: "20px", flexWrap: "wrap" }}>
        {/* Password Form Card */}
        <div style={{
          background: "#ffffff",
          borderRadius: "12px",
          border: "1px solid #e2e8f0",
          padding: "24px",
          flex: "1 1 400px",
          maxWidth: "500px",
        }}>
          <div style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            marginBottom: "20px",
          }}>
            <div style={{
              width: "32px",
              height: "32px",
              borderRadius: "8px",
              background: "linear-gradient(135deg, #f5f3ff 0%, #ede9fe 100%)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}>
              <FiKey size={16} color="#8B5CF6" />
            </div>
            <span style={{ fontSize: "14px", fontWeight: 600, color: "#1e293b" }}>
              Update Password
            </span>
          </div>

          <Form layout="vertical" name="password-form">
            <Form.Item
              label={
                <span style={{ fontSize: "13px", fontWeight: 500, color: "#475569" }}>
                  {t("profile.plans.oldPassword")}
                </span>
              }
              name="old-password"
              rules={[
                {
                  required: true,
                  message: t("profile.plans.oldPasswordMessage"),
                },
              ]}
              style={{ marginBottom: "16px" }}
            >
              <Input.Password
                placeholder="Enter your current password"
                style={{
                  padding: "10px 14px",
                  borderRadius: "8px",
                  border: "1px solid #e2e8f0",
                  fontSize: "14px",
                }}
              />
            </Form.Item>

            <Form.Item
              label={
                <span style={{ fontSize: "13px", fontWeight: 500, color: "#475569" }}>
                  {t("profile.plans.newPassword")}
                </span>
              }
              name="new-password"
              rules={[
                {
                  required: true,
                  message: t("profile.plans.newPasswordMessage"),
                },
              ]}
              style={{ marginBottom: "16px" }}
            >
              <Input.Password
                placeholder={t("profile.plans.newPasswordPH")}
                style={{
                  padding: "10px 14px",
                  borderRadius: "8px",
                  border: "1px solid #e2e8f0",
                  fontSize: "14px",
                }}
              />
            </Form.Item>

            <Form.Item
              label={
                <span style={{ fontSize: "13px", fontWeight: 500, color: "#475569" }}>
                  {t("profile.plans.confirmPassword")}
                </span>
              }
              name="confirm-new-password"
              rules={[
                {
                  required: true,
                  message: t("profile.plans.confirmPasswordMessage"),
                },
              ]}
              style={{ marginBottom: "20px" }}
            >
              <Input.Password
                placeholder={t("profile.plans.confirmPasswordPH")}
                style={{
                  padding: "10px 14px",
                  borderRadius: "8px",
                  border: "1px solid #e2e8f0",
                  fontSize: "14px",
                }}
              />
            </Form.Item>

            <Form.Item style={{ marginBottom: 0 }}>
              <button
                type="button"
                onClick={() =>
                  InfoNotification(t("profile.plans.changePasswordFromLoginPage"))
                }
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                  padding: "12px 20px",
                  borderRadius: "8px",
                  border: "none",
                  background: "linear-gradient(135deg, #8B5CF6 0%, #7C3AED 100%)",
                  color: "#fff",
                  fontSize: "14px",
                  fontWeight: 600,
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                  boxShadow: "0 2px 8px rgba(139,92,246,0.3)",
                }}
              >
                <FiLock size={16} />
                {t("profile.plans.changePassword")}
              </button>
            </Form.Item>
          </Form>
        </div>

        {/* Security Tips Card */}
        <div style={{
          background: "#ffffff",
          borderRadius: "12px",
          border: "1px solid #e2e8f0",
          padding: "24px",
          flex: "1 1 300px",
          maxWidth: "400px",
        }}>
          <div style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            marginBottom: "20px",
          }}>
            <div style={{
              width: "32px",
              height: "32px",
              borderRadius: "8px",
              background: "linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}>
              <FiShield size={16} color="#10b981" />
            </div>
            <span style={{ fontSize: "14px", fontWeight: 600, color: "#1e293b" }}>
              Password Requirements
            </span>
          </div>

          <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
            {passwordRequirements.map((req, idx) => (
              <div
                key={idx}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <div style={{
                  width: "20px",
                  height: "20px",
                  borderRadius: "50%",
                  background: req.met ? "#10b981" : "#e2e8f0",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}>
                  <FiCheck size={12} color={req.met ? "#fff" : "#94a3b8"} />
                </div>
                <span style={{
                  fontSize: "13px",
                  color: req.met ? "#1e293b" : "#64748b",
                }}>
                  {req.text}
                </span>
              </div>
            ))}
          </div>

          {/* Security Tips */}
          <div style={{
            marginTop: "24px",
            padding: "16px",
            background: "#faf5ff",
            borderRadius: "10px",
            border: "1px solid #e9d5ff",
          }}>
            <div style={{
              fontSize: "12px",
              fontWeight: 600,
              color: "#7C3AED",
              marginBottom: "8px",
              display: "flex",
              alignItems: "center",
              gap: "6px",
            }}>
              <span>💡</span> Security Tips
            </div>
            <ul style={{
              margin: 0,
              padding: "0 0 0 16px",
              fontSize: "12px",
              color: "#6D28D9",
              lineHeight: 1.6,
            }}>
              <li>Never share your password with anyone</li>
              <li>Use a unique password for each account</li>
              <li>Consider using a password manager</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PasswordInfo;
